export const SOFT_NAV_EXTERNAL_EVENTS = Object.freeze({
  INITIAL: 'soft-nav:external:initial',
  START: 'soft-nav:external:start',
  SUCCESS: 'soft-nav:external:success',
  ERROR: 'soft-nav:external:error',
  RENDER: 'soft-nav:external:render',
})
